<template>
    <div class="d-flex flex-column min-vh-100" :class="{ bg: route == 'workshops' }">
        <div class="container-fluid hero">
            <!-- top image bar -->
            <div class="container">
                <div class="row">
                    <div class="col-auto">
                        <img src="@/assets/logo.svg" class="d-block logo" />
                    </div>
                    <div class="col ml-auto">
                        <Navbar :pages="pages" />
                    </div>
                </div>
            </div>
        </div>

        <!-- content -->
        <div class="flex-grow-1">
            <div v-for="(q, ri) in quarks" :key="q.id">
                <!-- rows -->
                <div v-if="ri == 0" :class="getRowClass(q)">
                    <!-- first row -->
                    <div class="row mb-3">
                        <div v-for="(c, index) in q.nrCols" :class="q.colStyle[index]">
                            <div id="content" v-html="q.columns[index]"></div>
                        </div>
                    </div>
                </div>
                <div v-else class="container">
                    <!-- next rows -->
                    <div class="row mb-3 align-items-center" :class="{ 'shadow rounded-lg': q.configs[0] }">
                        <div v-for="(c, ci) in q.nrCols" :class="q.colStyle[ci]">
                            <!-- rotate if config is set and odd rows column-2 and even rows column-1 -->
                            <div
                                class="bg-white mx-0"
                                :class="{ 'shadow rounded-lg': q.configs[7], rotate: f(q.configs[7], ri, ci) }">
                                <div class="px-3" v-html="q.columns[ci]" @click="click"></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- footer -->
        <Footer />
    </div>
</template>

<script>
import Footer from '@/components/Footer.vue';
import Navbar from '@/components/NavbarX.vue';
import utils from '@/js/utils';

export default {
    data: () => ({
        tags: [],
    }),

    props: {
        route: String,
    },

    components: { Footer, Navbar },

    computed: {
        quarks() {
            let qq = this.$store.quarks;
            // console.log('main.vue computed quarks', qq.length);
            if (qq.length > 0) {
                this.handleQuarks(qq);
                // console.log(qq);
                return qq;
            }
        },
        pages() {
            let pages = this.$store.pages;
            if (pages.length > 0) {
                return pages;
            }
        },
        page() {
            let p = this.route;
            if (p == '/') p = 'home';
            let page = this.$store.getPage(p);
            return page;
        },
    },

    created: function () {
        // console.clear();
        // var tzoffset = new Date().getTimezoneOffset() * 60000; //offset in milliseconds
        // var localISOTime = new Date(Date.now() - tzoffset).toISOString().slice(0, -5).replace('T', ' ');
        // console.log('main', localISOTime);
    },
    mounted() {
        // this.anchorHashCheck();
    },

    methods: {
        // anchorHashCheck() {
        //     console.log('this.anchorHashCheck', this.$route.hash, window.location.hash);

        //     // if (window.location.hash === this.$route.hash) {
        //     const el = document.getElementById(this.$route.hash.slice(1));
        //     if (el) {
        //         console.log(el.offsetTop);
        //         window.scrollTo(0, el.offsetTop);
        //     }
        //     // }
        // },

        f(config, ri, ci) {
            return config && ((ri % 2 == 1 && ci % 2 == 1) || (ri % 2 == 0 && ci % 2 == 0));
        },

        handleQuarks(arr) {
            // console.log('arr', arr.length, arr);
            utils.sortByRank(arr);

            let h1count = 0;

            arr.forEach((q) => {
                // determine which column title belongs to
                if (q.title != null) {
                    let spl = q.title.split(';');
                    if (spl.length == 1) {
                        q.titleCol = 0;
                    } else {
                        q.title = spl[0];
                        q.titleCol = spl[1];
                    }
                }

                // new property - column configuration
                q.configs = [0, 0, 0, 0, 0, 0, 0, 0];
                for (let i = 0; i < q.configs.length; i++) {
                    let mask = 1 << i;
                    q.configs[i] = (q.config & mask) == mask ? 1 : 0;
                }

                // new property - column styles
                if (!Array.isArray(q.cols)) q.cols = q.cols.split(';');
                q.colStyle = [];
                let i = 0;
                q.cols.forEach((style) => {
                    q.colStyle[i] = 'col-md-' + style;
                    if (q.configs[i + 1]) q.colStyle[i] += ' shadow rounded-lg';
                    i++;
                });

                // new property - number of columns
                q.nrCols = q.cols.length;

                // new property - columns as array
                q.columns = [];
                q.columns.push(q.col1);
                q.columns.push(q.col2);
                q.columns.push(q.col3);
                q.columns.push(q.col4);

                // make all images responsive
                for (let i = 0; i < q.columns.length; i++) {
                    // console.log('config', q.config);
                    let el = q.columns[i];
                    if (el != null) {
                        const output = utils.replaceImages(el);
                        console.log('output:');
                        console.log(output);
                        q.columns[i] = output;
                    }
                }

                // check for h1 elements
                if (q.columns[0].indexOf('<h1>') != -1) {
                    let h1new = '<h1 id="section-' + h1count + '">';
                    this.tags.push('#section-' + h1count);
                    h1count++;
                    q.columns[0] = q.columns[0].replaceAll('<h1>', h1new);
                    // console.log(q.columns[0]);
                    // console.log('h1', h1new);
                }

                // convert trigger text into button
                let trigger = '<p>***aanmelden';
                for (let i = 0; i < 4; i++) {
                    let pos1 = q.columns[i].indexOf(trigger);
                    if (pos1 != -1) {
                        let pos2 = q.columns[i].indexOf('</p>', pos1);
                        let complete = q.columns[i].substring(pos1, pos2 + 4);
                        // console.log('complete', complete);
                        let subject = q.columns[i].substring(pos1 + trigger.length + 1, pos2 - 3);
                        // console.log('subject', subject);
                        let link = 'mailto:petra@queenie.nl?subject=' + subject;
                        let pNew = '<a href="' + link + '"><p class="mailBtn mb-0">Ik geef mij op!</p></a>';
                        q.columns[i] = q.columns[i].replace(complete, pNew);
                    }
                }
                trigger = '<p>***afspraakmaken';
                for (let i = 0; i < 4; i++) {
                    let pos1 = q.columns[i].indexOf(trigger);
                    if (pos1 != -1) {
                        let pos2 = q.columns[i].indexOf('</p>', pos1);
                        let complete = q.columns[i].substring(pos1, pos2 + 4);
                        // console.log('complete', complete);
                        let subject = q.columns[i].substring(pos1 + trigger.length + 1, pos2 - 3);
                        // console.log('subject', subject);
                        let link = 'mailto:petra@queenie.nl?subject=' + subject;
                        let pNew = '<a href="' + link + '" class="appointmentBtn mb-0">Ik wil een afspraak maken</a>';
                        q.columns[i] = q.columns[i].replace(complete, pNew);
                    }
                }
            });
        },

        // getColumnClass(q, index) {
        //     let obj = '';

        //     // color and background per column
        //     // switch (index) {
        //     //     case 0:
        //     //         obj = { configColorTop: q.configs[index + 1], colorPurple: q.configs[index + 1] };
        //     //         break;
        //     //     case 1:
        //     //         obj = { configColorTop: q.configs[index + 1], colorOrange: q.configs[index + 1] };
        //     //         break;
        //     //     case 2:
        //     //         obj = { configColorTop: q.configs[index + 1], colorBlue: q.configs[index + 1] };
        //     //         break;
        //     //     case 3:
        //     //         obj = { configColorTop: q.configs[index + 1], colorGreen: q.configs[index + 1] };
        //     //         break;
        //     // }

        //     // responsive order
        //     if (q.configs[index + 1]) {
        //         obj = 'order-first order-sm-first order-md-last';
        //     }

        //     return obj;
        // },

        getRowClass(q) {
            let obj = q.configs[0] ? '' : 'container';
            return obj;
        },

        click(e) {
            const elt = e.target.closest('.mailBtn');
            if (elt) {
                console.log('button click');
            }
        },
    },
};
</script>

<style>
.hero {
    background-color: #ee6f36;
    height: 98px;
}

.logo {
    margin-top: 1.7rem !important;
    height: 125px;
}

.img-wide {
    display: block;
    margin-left: auto;
    margin-right: auto;
    width: 100%;
    height: 300px;
    object-fit: cover;
}

.mailBtn {
    background-color: #ed672b;
    border-radius: 0 0 0.3rem 0.3rem;
    text-align: center;
    font-family: 'RobotoSlab';
    font-size: 24px;
    color: white;
    padding-top: 16px;
    padding-bottom: 16px;
    margin-left: -1rem;
    margin-right: -1rem;
    cursor: pointer;
}

.appointmentBtn {
    background-color: #ed672b;
    border-radius: 0.3rem 0.3rem 0.3rem 0.3rem;
    text-align: center;
    font-family: 'RobotoSlab';
    font-size: 24px;
    color: white;
    padding: 12px 16px;
    margin: 16px 0;
    cursor: pointer;
}

.img-fluid {
    width: 100%;
    height: auto;
}

.rotate {
    transform: rotate(2deg);
}

.bg {
    background-image: url('../assets/background.jpg');
    background-size: cover;
    background-position: center;
}
</style>
